export default "__VITE_ASSET__xp06QUPj__"